// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/sidebar/roundtop.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/sidebar/roundbottom.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  font-family: 'Roboto', sans-serif;
  margin: 0;
  background: #f5f6ff;
}

.loadingAnimation {
  animation: action 1s infinite alternate;
}

@keyframes action {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-24px);
  }
}

.AppMenuItem {
  position: relative;
}
.AppMenuItem.active::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  height: 16px;
  width: 16px;
  position: absolute;
  right: 0;
  top: -15px;
}
.AppMenuItem.active::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  position: absolute;
  height: 16px;
  width: 16px;
  position: absolute;
  right: 0;
  bottom: -15px;
}
@media print {
  .no-print {
    display: none !important;
  }
}

/* .AppMenuItem.active::after {
  content: '';
  position: absolute;
  height: 24px;
  width: 24px;
  background: #393a96;
  border-radius: 0 0 24px 0;
  position: absolute;
  right: 0;
  top: -24px;
  box-shadow: 0px 0px 0 #fff;
} */
`, "",{"version":3,"sources":["webpack://./src/assets/css/app.css"],"names":[],"mappings":"AAAA;;EAEE,iCAAiC;EACjC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EAEE,uCAAuC;AACzC;;AAYA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gDAA8C;EAC9C,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,gDAAiD;EACjD,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,aAAa;AACf;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;;;;;;;;;;;GAWG","sourcesContent":["body,\nhtml {\n  font-family: 'Roboto', sans-serif;\n  margin: 0;\n  background: #f5f6ff;\n}\n\n.loadingAnimation {\n  -webkit-animation: action 1s infinite alternate;\n  animation: action 1s infinite alternate;\n}\n\n@-webkit-keyframes action {\n  0% {\n    transform: translateY(0);\n  }\n\n  100% {\n    transform: translateY(-24px);\n  }\n}\n\n@keyframes action {\n  0% {\n    transform: translateY(0);\n  }\n\n  100% {\n    transform: translateY(-24px);\n  }\n}\n\n.AppMenuItem {\n  position: relative;\n}\n.AppMenuItem.active::before {\n  content: url('../images/sidebar/roundtop.png');\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  position: absolute;\n  right: 0;\n  top: -15px;\n}\n.AppMenuItem.active::after {\n  content: url('../images/sidebar/roundbottom.png');\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  position: absolute;\n  right: 0;\n  bottom: -15px;\n}\n@media print {\n  .no-print {\n    display: none !important;\n  }\n}\n\n/* .AppMenuItem.active::after {\n  content: '';\n  position: absolute;\n  height: 24px;\n  width: 24px;\n  background: #393a96;\n  border-radius: 0 0 24px 0;\n  position: absolute;\n  right: 0;\n  top: -24px;\n  box-shadow: 0px 0px 0 #fff;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
